import React from 'react';
import clsx from 'clsx';
import {
  CPTCodeSuggestionDTO,
} from 'dtos';
import Checkbox from 'pages/Dashboard/components/Input/Checkbox';
import {
  useSelectableContext,
} from 'core/hooks';

type Props = CPTCodeSuggestionDTO & {
  onChange: (checked: boolean) => void;
};

export default function SuggestedCode({
  code,
  description,
  onChange,
}: Props) {
  const { isSelected, toggle } = useSelectableContext();
  const checked = isSelected(code ?? '');

  return (
    <Checkbox
      id={code ?? ''}
      className={clsx({ '!text-blue-500': checked })}
      containerClassName="!items-start"
      checked={checked}
      onChange={(checked) => {
        onChange(checked);
        toggle(code ?? '');
      }}
      label={(
        <p>
          <strong>{code}</strong>
          {' '}
          -
          {' '}
          {description}
        </p>
      )}
    />
  );
}
